import "./work-wooords.css";
import OurWorksSection from "../../../components/our-works-section/OurWorksSection";

function WorkWooords() {
  const id = 7;

  return (
    <div className="work wooords">
      {/* Work Header */}
      <div className="work-header">
        <div className="work-branding">
          <div className="work-branding-title">
            <div className="work-branding-title-col-1">
              {window.innerWidth <= 768 ?
                <img
                  src="/assets/icons/partner-companies-logos/wooords.svg"
                  alt="Wooords Logo"
                /> :
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FCFF53" }}
                >
                  <span>WOOORDS - </span> Kids Posters
                </h2>
              }
              {window.innerWidth <= 768 ?
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FCFF53" }}
                >
                  <span>WOOORDS - </span> Kids Posters
                </h2>
                :
                <button
                  onClick={() => window.open("https://www.behance.net/gallery/140261723/ADesign-E-Commerce-UXUI-Minimal-Concept", "_blank")}
                >
                  Discover
                  &nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
                    <path d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z" fill="#050320" />
                  </svg>
                </button>
              }
            </div>
            <div
              className={`work-branding-title-col-2  ${window.innerWidth <= 768 ? "d-none" : ""
                }`}
            >
              <img
                src="/assets/icons/partner-companies-logos/wooords.svg"
                alt="Wooords Logo"
              />
            </div>
          </div>
          <h1
            className={`animate__animated animate__fadeIn animate__slow ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
          >
            Check out our fun collection of kids' prints and posters for your child's room!
          </h1>
        </div>

        <img
          src="/assets/images/work-pages/wooords/wooords-1.webp"
          alt="Work Image"
        />

        <h1 className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Check out our fun collection of kids' prints and posters for your child's room!
        </h1>

        <button
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          onClick={() => window.open("https://www.behance.net/gallery/140261723/ADesign-E-Commerce-UXUI-Minimal-Concept", "_blank")}
        >
          Discover
          &nbsp;
          <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
            <path d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z" fill="#050320" />
          </svg>
        </button>
      </div>

      {/* Work Desc Section */}
      <div className="work-desc-section">
        <div className="work-desc">
          <p>
            Charming and funny posters and prints for children. These playful illustrations, typographies and photographs make perfect wall art for your child's room.
          </p>
          <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
            Brighten up any kid's room or school with vibrant kids posters! These fun prints come in a variety of themes, from adventurous animals to outer space
          </p>
        </div>
        <div
          className={`work-provided-services ${window.innerWidth <= 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Wireframing</li>
            <li>UI/UX Design</li>
            <li>Web App Design</li>
            <li>Responsive Design</li>
          </ul>
        </div>
      </div>

      {/* Work Section 1 */}
      <div className="work-section-1">
        <h1 className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>Dedicated Specifically To The Pleasure Of Younger. </h1>
        <img
          src="/assets/images/work-pages/wooords/wooords-2.webp"
          alt="Work Image"
        />

        <div
          className={`work-provided-services ${window.innerWidth > 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Wireframing</li>
            <li>UI/UX Design</li>
            <li>Web App Design</li>
            <li>Responsive Design</li>
          </ul>
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Brighten up any kid's room or school with vibrant kids posters! These fun prints come in a variety of themes, from adventurous animals to outer space
        </p>
      </div>

      {/* Work Section 2 */}
      <div className="work-section-2">
        <h1>Be Creative With Colors In Powerful Shades.</h1>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Play, paint, mix and express your creativity with watercolors, finger paint and gouache colors. Mix them together and discover new shades, play with the finger paint and create a painting of your hands. When you start to explore the world of paint, there is almost no limitations!
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          When kids are being creative, you might end up with paint almost everywhere. That is why we only have paint that is easy to wash off. Just use soap and water on textiles and hands after use.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Paint makes it possible to be more playful, creative and expressive than ever!
        </p>
        <img
          src="/assets/images/work-pages/wooords/wooords-3.webp"
          alt="Work Image"
        />
        <div className="d-flex justify-content-center">
          <img
            src="/assets/images/work-pages/wooords/wooords-4.webp"
            alt="Work Image"
          />
          <img
            src="/assets/images/work-pages/wooords/wooords-5.webp"
            alt="Work Image"
          />
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Play, paint, mix and express your creativity with watercolors, finger paint and gouache colors. Mix them together and discover new shades, play with the finger paint and create a painting of your hands. When you start to explore the world of paint, there is almost no limitations!
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          When kids are being creative, you might end up with paint almost everywhere. That is why we only have paint that is easy to wash off. Just use soap and water on textiles and hands after use.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Paint makes it possible to be more playful, creative and expressive than ever!
        </p>
      </div>

      {/* Work Section 3 */}
      <div className="work-section-3">
        <h1>The Results</h1>
        <img
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/wooords/wooords-6.webp"
          alt="Work Image"
        />
        <p>
          Brighten up any kid's room or school with vibrant kids posters! These fun prints come in a variety of themes, from adventurous animals to outer space explorations. They’re an easy way to add some flair to walls while inspiring creativity and learning. Ideal for playrooms and classrooms!
          <br />
          <br />
          Charming and funny posters and prints for children. These playful illustrations, typographies and photographs make perfect wall art for your child's room.
        </p>
        <h2>
          The outcome: a refreshing and professional website design that reflects the unmatched features and services provided by TiMN
        </h2>
        <img
          className={`${window.innerWidth <= 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/wooords/wooords-6.webp"
          alt="Work Image"
        />
      </div>

      <OurWorksSection workPageId={id} />
    </div>
  );
}

export default WorkWooords;
